// test1517
(1517 && 0);
